// @ts-check
import React, { Component } from 'react';
import { Page, Row, Widget } from 'shared/containers/portal_layout';
import api from 'utils/api';
import LoadingContent from 'shared/components/LoadingContent';
import HForm, {
  TextField,
  PlainSelectField,
  DateMaskField,
  PlainCountySelectionField,
} from 'shared/containers/portal_layout/HForm';
import { reduxForm, Field, formValueSelector } from 'utils/reduxFormWrapper';
import Errors from 'shared/components/Errors';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import { Link, browserHistory } from 'react-router';
import { decamelizeKeys } from 'humps';
import SpinnerButton from 'shared/components/SpinnerButton';
import PatientCoverageForm from 'shared/components/PatientCoverage/Form';
import { connect } from 'react-redux';

class Show extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { patientActiveStatuses: null, locations: null };
    this.createPatientMember = this.createPatientMember.bind(this);
  }

  componentDidMount() {
    api.get('/agent_portal/api/patient_members/new').then(response => {
      this.setState({ ...response.data });
    });
  }

  createPatientMember(formValues) {
    return api
      .post(`/agent_portal/api/patient_members`, {
        patient_member: decamelizeKeys(formValues),
      })
      .then(response => {
        FlashMessageActions.flashSuccess({ message: 'Patient successfully created' });
        browserHistory.push(`/a/portal/patient_members/${response.data.id}`);
        return null;
      });
  }

  render() {
    if (!this.state.patientActiveStatuses || !this.state.locations) return <LoadingContent />;
    return (
      <FormifiedPresentationComponent
        patientActiveStatuses={this.state.patientActiveStatuses}
        locations={this.state.locations}
        states={this.state.states}
        form="newPatientMember"
        onSubmit={this.createPatientMember}
      />
    );
  }
}

const PresentationComponent = ({
  locations,
  patientActiveStatuses,
  handleSubmit,
  error,
  submitting,
  form,
  zip,
  states,
}) => (
  <Page title="New Patient">
    <div className="row-fluid">
      <div className="span12">
        <Link to="/a/portal/patient_members">&lt;&lt; Back to Patient List</Link>
      </div>
    </div>
    <Row>
      <Widget
        className="nopadding"
        title="New Patient - Please fill in all fields on this form"
        span={12}
      >
        <HForm onSubmit={handleSubmit}>
          <Errors errors={error || []} />
          <PlainSelectField
            name="locationId"
            label="Assigned Location"
            options={locations}
            labelKey="name"
            valueKey="id"
            prompt={locations.length === 1 ? false : 'Choose location...'}
          />
          <TextField name="medicalRecordNumber" label="Patient MRN" />
          <TextField name="patientAttributes.lastName" label="Patient Last Name" />
          <TextField name="patientAttributes.firstName" label="Patient First Name" />
          <DateMaskField
            name="patientAttributes.dobString"
            label="Patient DOB"
            mask="dob"
            placeholder="mm/dd/yyyy"
          />
          <TextField name="patientAttributes.formattedPrimaryPhone" label="Patient Primary Phone" />
          <TextField
            name="patientAttributes.formattedSecondaryPhone"
            label="Patient Secondary Phone"
          />
          <TextField name="email" label="Patient Email" />
          <TextField name="formattedSsn" label="Patient SSN" />

          <PatientCoverageForm form={form} prefix="patientAttributes.patientCoverageAttributes" />

          <TextField
            name="patientAttributes.zip"
            label="Patient Zip"
            className="input-small"
            placeholder="zip code"
          />
          <PlainCountySelectionField
            className="input-xlarge"
            name="patientAttributes.fipsCode"
            label="Patient County"
            zip={zip}
          />
          <TextField
            name="patientAttributes.streetAddress"
            label="Patient Street Address"
            className="input-medium"
            placeholder="address"
          />
          <TextField
            name="patientAttributes.city"
            label="Patient City"
            className="input-medium"
            placeholder="city"
          />
          <PlainSelectField
            name="patientAttributes.stateId"
            label="Patient State"
            className="input-medium"
            options={states}
            valueKey="id"
            labelKey="name"
          />
          <PlainSelectField
            name="patientActiveStatusId"
            label="Patient Active"
            options={patientActiveStatuses}
            labelKey="name"
            valueKey="id"
            prompt={false}
          />
          <Field
            name="patientActiveStatusId"
            render={({ input: { value } }) => {
              const patientActiveStatus = patientActiveStatuses.find(s => s.id === value);
              if (patientActiveStatus && patientActiveStatus.name === 'No - Other') {
                return (
                  <TextField
                    name="patientStatusNote"
                    label="Patient Status Note"
                    className="input-large"
                  />
                );
              }
              return null;
            }}
          />
          <div className="form-actions">
            <SpinnerButton type="submit" className="btn btn-primary" loading={submitting}>
              Save
            </SpinnerButton>
          </div>
        </HForm>
      </Widget>
    </Row>
  </Page>
);

const mapStateToProps = (state, ownProps) => {
  const zip = formValueSelector(ownProps.form)(state, 'patientAttributes.zip');
  return {
    zip,
  };
};

const FormifiedPresentationComponent = reduxForm({})(
  connect(mapStateToProps)(PresentationComponent)
);

export default Show;
